/** A file picked twice (same name, size and date) is kept once. */
function fileIdentity(file: File): string {
  return `${file.name}|${file.size}|${file.lastModified}`;
}

/** Appends `picked` to `current`, skipping files that are already there. */
export function mergeFiles(current: File[], picked: File[]): File[] {
  const seen = new Set(current.map(fileIdentity));
  const added = picked.filter((file) => {
    const id = fileIdentity(file);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
  return added.length === 0 ? current : [...current, ...added];
}
